module.exports = __webpack_public_path__ + "img/skull_5_bj.d0ce46d3.png";